import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FORM_URL } from 'app/@common/constants'

export default function SelectTimeZone({...props}) {

    const myProps = {
        urlAjax: FORM_URL.TIME_ZONE,
        placeholder: i18n.t('common:filters.timeZone'), icon: {icon: 'globe'},
        isClearable: true,
        isMulti: false,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}